import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import { ExpertiseSection, DistressDealsSection } from './components/Sections';
import {
  NewLaunchSection,
  HomeInspectionSection,
  LoanSection,
  PopularCitiesSection,
  TrustedDevelopersSection,
  Footer,
} from './components/MoreSections';
import { Toaster } from './components/ui/toaster';
import ListingsPage from './pages/ListingsPage';
import PropertyDetailPage from './pages/PropertyDetailPage';
import OwnerListingsPage from './pages/OwnerListingsPage';
import OwnerListingDetailPage from './pages/OwnerListingDetailPage';
import OwnerListingsSection from './components/OwnerListingsSection';
import { AdminAuthProvider } from './lib/adminAuth';
import { AdminNotificationsProvider } from './lib/adminNotifications';
import { SettingsProvider } from './lib/settings';
import AdminProtectedRoute from './components/AdminProtectedRoute';
import AdminLoginPage from './pages/admin/AdminLoginPage';
import AdminDashboardPage from './pages/admin/AdminDashboardPage';
import AdminPropertiesPage from './pages/admin/AdminPropertiesPage';
import AdminPropertyEditorPage from './pages/admin/AdminPropertyEditorPage';
import AdminInterestsPage from './pages/admin/AdminInterestsPage';
import AdminServiceRequestsPage from './pages/admin/AdminServiceRequestsPage';
import AdminPropertySubmissionsPage from './pages/admin/AdminPropertySubmissionsPage';
import AdminSettingsPage from './pages/admin/AdminSettingsPage';

const Home = () => (
  <div className="min-h-screen bg-white">
    <Header />
    <main>
      <HeroSection />
      <ExpertiseSection />
      <DistressDealsSection />
      <OwnerListingsSection />
      <NewLaunchSection />
      <HomeInspectionSection />
      <LoanSection />
      <PopularCitiesSection />
      <TrustedDevelopersSection />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <SettingsProvider>
      <AdminAuthProvider>
        <AdminNotificationsProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/listings" element={<ListingsPage />} />
            <Route path="/property/:id" element={<PropertyDetailPage />} />
            <Route path="/owner-listings" element={<OwnerListingsPage />} />
            <Route path="/owner-listings/:id" element={<OwnerListingDetailPage />} />

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<AdminProtectedRoute><AdminDashboardPage /></AdminProtectedRoute>} />
            <Route path="/admin/properties" element={<AdminProtectedRoute><AdminPropertiesPage /></AdminProtectedRoute>} />
            <Route path="/admin/properties/new" element={<AdminProtectedRoute><AdminPropertyEditorPage /></AdminProtectedRoute>} />
            <Route path="/admin/properties/:id/edit" element={<AdminProtectedRoute><AdminPropertyEditorPage /></AdminProtectedRoute>} />
            <Route path="/admin/interests" element={<AdminProtectedRoute><AdminInterestsPage /></AdminProtectedRoute>} />
            <Route path="/admin/service-requests" element={<AdminProtectedRoute><AdminServiceRequestsPage /></AdminProtectedRoute>} />
            <Route path="/admin/property-submissions" element={<AdminProtectedRoute><AdminPropertySubmissionsPage /></AdminProtectedRoute>} />
            <Route path="/admin/settings" element={<AdminProtectedRoute><AdminSettingsPage /></AdminProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        </AdminNotificationsProvider>
      </AdminAuthProvider>
      </SettingsProvider>
      <Toaster />
    </div>
  );
}

export default App;
